import {
  faCalendar,
  faCalendarClock,
  faCheckSquare,
  faCircleDot,
  faClock,
  faCommentDots,
  faFunction,
  faImage,
  faInputNumeric,
  faInputText,
  faKey,
  faLink,
  faListDropdown,
  faLocationDot,
  faObjectGroup,
  faPen,
  faRectanglesMixed,
  faSquareBolt,
  faSubtitles,
  faTable,
  faTag,
  faUserGroup,
  faUsersViewfinder,
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const fieldIconMap = {
  TextField: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faInputText}
        fontSize={18}
      />
    );
  },
  List: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faListDropdown}
        fontSize={18}
      />
    );
  },
  TextArea: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faSubtitles}
        fontSize={18}
      />
    );
  },
  Numeric: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faInputNumeric}
        fontSize={18}
      />
    );
  },
  Label: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faTag}
        fontSize={18}
      />
    );
  },
  RadioButton: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faCircleDot}
        fontSize={18}
      />
    );
  },
  Section: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faObjectGroup}
        fontSize={18}
      />
    );
  },
  PeoplePicker: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faUserGroup}
        fontSize={18}
      />
    );
  },
  GroupPicker: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faUsersViewfinder}
        fontSize={18}
      />
    );
  },
  BusinessUnit: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faLocationDot}
        fontSize={18}
      />
    );
  },
  Date: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faCalendar}
        fontSize={18}
      />
    );
  },
  Checkbox: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faCheckSquare}
        fontSize={18}
      />
    );
  },
  CheckboxGroup: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faCheckSquare}
        fontSize={18}
      />
    );
  },
  DateTime: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faCalendarClock}
      />
    );
  },
  Time: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faClock}
      />
    );
  },
  Calculated: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faFunction}
      />
    );
  },
  Gallery: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faRectanglesMixed}
        fontSize={18}
      />
    );
  },
  Table: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faTable}
        fontSize={18}
      />
    );
  },
  FileUpload: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faTable}
        fontSize={18}
      />
    );
  },
  ImageLabel: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faImage}
        fontSize={18}
      />
    );
  },
  Hyperlink: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faLink}
        fontSize={18}
      />
    );
  },
  Index: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faKey}
        fontSize={18}
      />
    );
  },
  TableIndex: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faKey}
        fontSize={18}
      />
    );
  },
  Button: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faSquareBolt}
        fontSize={18}
      />
    );
  },
  ContinuousComments: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faCommentDots}
        fontSize={18}
      />
    );
  },
  Signature: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faPen}
        fontSize={18}
      />
    );
  },
};
